export default "__VITE_ASSET__134d788e__"